import React, {Component} from 'react';
import axios from 'axios';
import UserListItem from './UserListItem';
import CapitalizedText from './CapitalizedText';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    axios.get('https://randomuser.me/api/?results=25')
      .then((response) => {
        this.setState({
          users: response.data.results
        });
      })
      .catch(() => {
        this.setState({ message: 'please try again later' });
      })
  }
  
  // CapitalizedText(str) {
  //   return str.charAt(0).toUpperCase() + str.slice(1);
  // }

  handleDelete(e) {
    if(window.confirm('Delete this user?')) {
      this.state.users.splice(e, 1);
      this.setState({
        users: this.state.users
      });
    }
  }
  
  render() {
    return (
      <div className="App">
        <ul>
          {this.state.users.map((user, index) => {
            const imageUrlFemale='https://cdn5.vectorstock.com/i/1000x1000/98/89/woman-girl-female-hair-person-face-head-icon-vector-10189889.jpg';
            const imageUrlMale='https://cdn4.iconfinder.com/data/icons/avatars-32/90/24-512.png';
            const imageUrlUS='https://cdn.webshopapp.com/shops/94414/files/54959460/the-united-states-flag-icon-free-download.jpg';
            let genderImage, natImage;
            if(user.gender === 'female') {
              genderImage = imageUrlFemale;
            }
            else {
              genderImage = imageUrlMale;
            }
            if(user.nat === 'US') {
              natImage = imageUrlUS;
            }
              return(
                <UserListItem 
                  key={index}
                  value={index}
                  name={CapitalizedText(user.name.first)}
                  fname={CapitalizedText(user.name.first)}
                  lname={CapitalizedText(user.name.last)}
                  imageUrl={user.picture.thumbnail}
                  city={CapitalizedText(user.location.city)}
                  state={CapitalizedText(user.location.state)}
                  email={user.email}
                  gender={user.gender}
                  genderImage={genderImage}
                  nat={user.nat}
                  natImage={natImage}
                  onClick={this.handleDelete}
                />
              );
            })}
        </ul>
        {this.state.message && (
          <p>{this.state.message}</p>
        )}
      </div>
    );
  }
}

export default App;
